import { convertCurrencyToUsd, formatPrice } from '@vy/services';
import {
  COMMITMENT_TYPES,
  CommitmentType,
  Currency,
  CurrencyExchangeRates,
  DEFAULT_CURRENCY,
} from '@vy/types';
import { formatNumber, isNullOrUndefined } from '@vy/utils';

export function formatCommitmentAmount(
  commitmentType: CommitmentType,
  amount: number,
  currency: Currency,
  exchangeRates?: CurrencyExchangeRates,
) {
  if (commitmentType === COMMITMENT_TYPES.Units) {
    return formatNumber(amount);
  }

  if (currency === DEFAULT_CURRENCY) {
    return formatPrice(amount, DEFAULT_CURRENCY);
  }

  if (isNullOrUndefined(exchangeRates)) return '--';

  const convertedAmount = convertCurrencyToUsd(amount, currency, exchangeRates);

  return formatPrice(convertedAmount, DEFAULT_CURRENCY);
}
